import type { DeviceWithoutLocation } from '@/features/devices/types/device'
import type { CreateJobPayload } from '@/features/jobs/types/job-form'
import type { JobType } from '@/features/jobs/types/job'
import { apiClient } from '@/lib/api/api-client'
import type { Location } from '@/shared/types/location'

export type CreatedJob = {
  id: number
  date_raised: string
  job_type: JobType
  reason_for_remediation: string | null
  location: Location
  device_attached: DeviceWithoutLocation | null
}

export const apiCreateJob = (body: CreateJobPayload) =>
  apiClient<CreatedJob>('/api/v1/jobs', {
    method: 'POST',
    body: JSON.stringify(body),
  })
